export const enum ActivityDetailsTemplateId {
  TicketRates = 'ticket-rates',
}
